import React from 'react';
import KnaekPrimaryButton from "../../AppComponents/KnaekPrimaryButton";
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import {useHandleLinkClick} from "../../../hooks/useHandleLinkClick";


export default function Section6and7ForCompanies() {
    const handleLinkClick = useHandleLinkClick();


    const initStrings = {
        buttonText: stringsTranslate(appWords.contact_us),
        headingSection1_1: stringsTranslate(appWords.building_loyalty),
        subheadingSection1_1:  stringsTranslate(appWords.use_as_loyalty_tool),


        headingSection1_2: stringsTranslate(appWords.what_makes_knaek_unique),
        subheadingSection1_2_1: stringsTranslate(appWords.focus_on_local_visibility),
        subheadingSection1_2_2: stringsTranslate(appWords.student_funded_affordability),

        headingSection1_3: stringsTranslate(appWords.good_to_know),
        subheadingSection1_3_1: stringsTranslate(appWords.you_control_campaign),
        subheadingSection1_3_2: stringsTranslate(appWords.you_decide_coupon_amount),
        subheadingSection1_3_3: stringsTranslate(appWords.adjust_and_track_results),
        subheadingSection1_3_4: stringsTranslate(appWords.no_commission_or_hassle),
        playImg1: "/assets/images/ForCompanies/schermen 1.webp",

        headingSection2: stringsTranslate(appWords.what_does_knaek_cost_for_companies),
        subheadingSection2_1: stringsTranslate(appWords.knaek_cost_description),
        subheadingSection2_2: stringsTranslate(appWords.in_summary),
        subheadingSection2_3: stringsTranslate(appWords.no_coupon_commission),
        subheadingSection2_4: stringsTranslate(appWords.no_cost_per_click),
        subheadingSection2_5: stringsTranslate(appWords.fixed_monthly_fee_per_city),
        subheadingSection2_6: stringsTranslate(appWords.students_cover_90_percent),
        subheadingSection2_7: stringsTranslate(appWords.affordable_and_effective),
        subheadingSection2_8: stringsTranslate(appWords.visibility_without_margin_loss),

        playImg2: "/assets/images/ForCompanies/Visual1 2.webp",
    }

    return (
        <section className="section ">
            <div className="container-fluid">
                {/*Section 6*/}

                <div className="row justify-content-center align-items-center mt-0 mt-lg-5 mt-md-5 px-2 px-md-5 px-lg-5 py-md-5 py-lg-5 py-0 ">

                    {/*1-1*/}
                    <div className="col-lg-12 col-md-12 flex-wrap d-flex align-items-center mt-5 list ">
                        <h2 className="pr-5">{initStrings.headingSection1_1}</h2>
                        <p className="mt-2 p-1 line-text ">{initStrings.subheadingSection1_1}</p>
                    </div>

                    <div className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-0 mt-lg-5 mt-md-5 list">

                        {/*1-2*/}
                        <h2 className="pr-0 pr-lg-5 pr-md-5 mt-5">{initStrings.headingSection1_2}</h2>
                        <p className="pr-0 pr-lg-5 pr-md-5 mt-2 p-1 line-text">{initStrings.subheadingSection1_2_1}</p>
                        <p className="pr-0 pr-lg-5 pr-md-5 mt-2 p-1 line-text">{initStrings.subheadingSection1_2_2}</p>


                        {/*1-3*/}
                        <h2 className="pr-0 pr-lg-5 pr-md-5 mt-5">{initStrings.headingSection1_3}</h2>
                        <ul>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p className={""}>{initStrings.subheadingSection1_3_1}</p>
                            </li>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p className={""}>{initStrings.subheadingSection1_3_2}</p>
                            </li>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p className={""}>{initStrings.subheadingSection1_3_3}</p>
                            </li>
                        </ul>
                        <p className="mt-2 p-1 pr-0 pr-lg-5 pr-md-5 line-text">{initStrings.subheadingSection1_3_4}</p>
                    </div>

                    <div className="col-lg-6 col-md-12 text-center mt-5 mt-lg-0 mt-md-0">
                        <img src={initStrings.playImg1} className={"w-100"} alt={""}/>
                    </div>

                </div>


                {/*Section 7*/}
                <div className="row mt-5 justify-content-center align-items-center px-2 px-md-5 px-lg-5 py-md-5 py-lg-5 py-0">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                        <KnaekPrimaryButton
                            title={initStrings.buttonText}
                            onClick={() => handleLinkClick("/contact")}

                        />
                    </div>

                    <div className="col-lg-6 col-md-12 text-center d-none d-lg-inline">
                        <img src={initStrings.playImg2} className={"w-100"} alt={""}/>
                    </div>


                    <div className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-5 list">
                        <h2 className="pr-5">{initStrings.headingSection2}</h2>

                        <p className="mt-2 p-1 line-text">{initStrings.subheadingSection2_1}</p>
                        <p className="mt-2 p-1 line-text">{initStrings.subheadingSection2_2}</p>
                        <ul>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p>{initStrings.subheadingSection2_3}</p>
                            </li>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p>{initStrings.subheadingSection2_4}</p>
                            </li>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p>{initStrings.subheadingSection2_5}</p>
                            </li>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p>{initStrings.subheadingSection2_6}</p>
                            </li>
                            <li className={"ml-2 line-text pr-0 pr-lg-5 pr-md-5"}>
                                <p>{initStrings.subheadingSection2_7}</p>
                            </li>
                        </ul>
                        <p className="mt-2 p-1 line-text">{initStrings.subheadingSection2_8}</p>

                    </div>


                </div>
            </div>
        </section>
    );

}
